import React from 'react';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/react-hooks';
import { useIntl } from 'react-intl';
import { REMOVE_INTERESTS } from './mutations';
import { growlActionSuccess } from '../../../utils/NotificationUtil';
import { withGrowl } from '../../../components/GrowlNotifications';
import { growlShape } from '../../../components/prop-types';
import messages from './intl-messages';

const DeactivateInterests = ({
  sourceAccountId, targetAccountId, growl, alreadyInUse, fetchData,
}) => {
  const [removeInterests] = useMutation(REMOVE_INTERESTS);
  const intl = useIntl();

  return (
    <>
      <Button
        type="button"
        className="p-button-secondary"
        icon="pi pi-lock"
        label={intl.formatMessage(messages.removeInterests)}
        disabled={alreadyInUse}
        onClick={async () => {
          await removeInterests({
            variables: {
              input: {
                sourceAccountId,
                targetAccountId,
              },
            },
          })
            .then(() => {
              growlActionSuccess(growl, intl.formatMessage(messages.removeInterestsSuccess));
              fetchData();
            })
            .catch(() => {
              growl.show({
                severity: 'error',
                detail: intl.formatMessage(messages.removeInterestsError),
                sticky: true,
              });
            });
        }}
      />
    </>
  );
};

DeactivateInterests.propTypes = {
  sourceAccountId: PropTypes.number.isRequired,
  targetAccountId: PropTypes.number.isRequired,
  growl: growlShape.isRequired,
  alreadyInUse: PropTypes.bool.isRequired,
  fetchData: PropTypes.func.isRequired,
};

export default withGrowl(DeactivateInterests);
